/* ================================================================
   Texte der Einführung — je Sprache.

   Bewusst getrennt vom Panel und von den Phrasenkatalogen unter
   ../i18n: Das hier ist Fließtext in Absätzen, kein Satzbaustein der
   Oberfläche. In einem nach deutschen Sätzen geschlüsselten Katalog
   wäre er weder les- noch pflegbar.

   Jede Sprache liefert dieselben Abschnittsschlüssel; welche davon
   erscheinen, entscheidet das Panel anhand der Freischaltungen.
   Fehlt eine Sprache, greift Deutsch.
   ================================================================ */

const TEXTE = {
  de: {
    "erste-schritte": {
      titel: "Erste Schritte",
      absatz: "Das Kellerbuch ist dreistufig aufgebaut: Eine Region (etwa Mosel) "
        + "enthält Winzer, ein Winzer seine Weine, ein Wein seine Jahrgänge. "
        + "Bestände hängen immer am Jahrgang, nie am Wein.",
      punkte: [
        ["Von oben nach unten anlegen", "Erst Region, dann Winzer, dann Wein. "
          + "Fehlt beim Anlegen eines Weins der Winzer, lässt er sich im selben Formular miterfassen — samt neuer Region."],
        ["Region mit Koordinaten", "Breiten- und Längengrad sind freiwillig, aber die Grundlage für Weltkarte und Witterung. "
          + "Sie lassen sich jederzeit nachtragen."],
        ["Jahrgang anlegen", "In der Ansicht eines Weins. Dort stehen Bestand je Flaschengröße, Kaufpreis, "
          + "Lagerort, Trinkfenster und die Analysewerte."],
        ["Ohne Jahrgang", "Für Champagner-Cuvées und ähnliche Weine gibt es „N.V.“ — davon sind auch mehrere je Wein möglich."],
      ],
    },
    keller: {
      titel: "Keller, Ein- und Auslagern",
      absatz: "Der Keller zeigt, was tatsächlich liegt. Jede Bewegung wird protokolliert, "
        + "damit Trink- und Kaufhistorie später auswertbar sind.",
      punkte: [
        ["Zugang", "Neue Flaschen mit Kaufdatum, Bezugsquelle und Kaufpreis buchen. Der Preis fließt in die Statistik ein."],
        ["Entnahme", "Getrunkene Flaschen ausbuchen. Im Anschluss lässt sich direkt eine Kritik zum Jahrgang erfassen."],
        ["Umlagern", "Flaschen zwischen Lagerorten bewegen, ohne den Bestand zu verändern."],
        ["Umfang der Listen", "Im Menü unter „Anzeigen“: „Keller mit Bestand“ blendet "
          + "leergetrunkene Jahrgänge aus (sie bleiben erhalten, mit Kritiken und Historie), "
          + "„Gesamter Keller“ zeigt auch sie, „Alle Weine“ zusätzlich den gemeinsamen Katalog."],
      ],
    },
    verlauf: {
      titel: "Trinkverlauf und Kritiken",
      absatz: "Der Trinkverlauf ist die Chronik des Kellers: Ein- und Auslagerungen, "
        + "Weinkarten-Buchungen und Kritiken stehen dort nebeneinander, nach Monaten "
        + "gruppiert. Im Menü direkt unter „Statistik“.",
      punkte: [
        ["Filtern", "Über die Auswahlliste nach Art (Einlagerungen, Entnahmen, Weinkarte, "
          + "Kritiken, Nicht zugeordnet), nach Jahr "
          + "und über die Suche nach Wein, Winzer, Händler oder Kritiker."],
        ["Kritik erfassen", "Über den Knopf im Trinkverlauf. Wein suchen, Jahrgang wählen, bewerten — "
          + "danach springt die Ansicht auf den Jahrgang. Fehlt der Wein noch, lässt er sich "
          + "im selben Formular anlegen, samt Winzer und Region."],
        ["Ohne Zuordnung", "Wenn der Wein im Moment nicht feststeht: „Ohne Zuordnung anlegen“. "
          + "Ein Hinweis zum Wein hilft beim Wiedererkennen, Pflicht ist er nicht. Solche "
          + "Kritiken erscheinen im Trinkverlauf unter „Nicht zugeordnet“ und lassen sich "
          + "dort später einem Wein zuschlagen."],
        ["Etikett vorab", "Das Foto darf schon aufgenommen werden, bevor der Wein feststeht — "
          + "es ist ja gerade das, was beim späteren Zuordnen hilft. Beim Zuordnen wandert es "
          + "an den Jahrgang, ohne erneut übertragen zu werden."],
        ["Ältere Kritiken", "Kritiken ohne eigenen Zeitstempel erscheinen am Datum der letzten "
          + "Entnahme desselben Jahrgangs; das ist als geliehen gekennzeichnet. Gab es nie eine "
          + "Entnahme, stehen sie unter „Ohne Datum“."],
      ],
    },
    finden: {
      titel: "Finden und Ordnen",
      absatz: "Suche und Filter greifen in Keller, Weinliste und Statistik. "
        + "Die Einstellungen bleiben erhalten, auch nach einem Neuladen.",
      punkte: [
        ["Suchfeld", "Das Kreuz rechts im Feld löscht die Eingabe. Daneben öffnen zwei Symbole "
          + "die Filter (Trichter) und die Sortierung (Balken); ein Punkt zeigt an, dass etwas gesetzt ist."],
        ["Filter", "Nach Typ, Land, Region, Winzer, Rebsorte, Jahrgang, Lagerort, Trinkreife und Lieblingswein. Je Filter lassen sich mehrere Werte anhaken, etwa mehrere Jahrgänge."],
        ["Label", "Ein freies Feld am Wein für die eigene Einordnung — etwa „New Wave Chardonnay“. "
          + "Labels lassen sich filtern und können die PDF-Weinkarte gliedern."],
        ["Trinkreife", "Aus dem Trinkfenster ergibt sich, ob ein Jahrgang noch zu jung, auf dem Punkt oder über dem Zenit ist."],
        ["Kritiken", "In vier Bewertungsschemata, wahlweise mit Anlass und Speisenbegleitung. "
          + "Das Standardschema wird im Menü unter „Mein Konto“ festgelegt."],
      ],
    },
    teilen: {
      titel: "Teilen und Weinkarten",
      absatz: "Beides erzeugt einen Link, der ohne Anmeldung geöffnet werden kann. "
        + "Für jede Freigabe wird einzeln bestimmt, welche Angaben sichtbar sind — "
        + "Verborgenes wird gar nicht erst übertragen.",
      punkte: [
        ["Keller teilen", "Zeigt den Bestand als Ganzes."],
        ["Weinkarte", "Eine Auswahl mit eigenen Preisen. Die Flaschen darauf sind dem Keller entnommen; "
          + "„Ausgeschenkt“ bucht sie als getrunken, das × legt sie zurück."],
        ["PDF", "Die Weinkarte lässt sich als PDF sichern — wahlweise mit Inhaltsverzeichnis und Seitenzahlen, "
          + "gegliedert nach Herkunft oder nach Label."],
        ["Sprache", "Die geteilte Karte kann in einer festen Sprache erscheinen; Gäste dürfen umschalten."],
      ],
    },
    katalog: {
      titel: "Gemeinsamer Katalog",
      absatz: "Im Cloud-Modus teilen sich alle Konten einen Stammdatenkatalog. "
        + "Bestände, Preise und Notizen bleiben davon unberührt — sie sind immer privat.",
      punkte: [
        ["Übernehmen", "Beim Anlegen eines Weins lässt sich nach Wein oder Winzer suchen. "
          + "Über den Winzer erscheinen dessen Weine zur Auswahl."],
        ["Jahrgänge", "Sie werden nicht automatisch übernommen. Beim Anlegen eines Jahrgangs "
          + "zeigt „Im Katalog verfügbar“ die Jahre, die der Katalog zu diesem Wein kennt; ein "
          + "Griff darauf übernimmt Trinkfenster, Etikett und Analysewerte. Eigene Eingaben "
          + "bleiben dabei stehen."],
        ["Vorschlagen", "Änderungen an übernommenen Stammdaten gehen als Vorschlag an die Verwaltung."],
        ["Lokal statt Cloud", "Unter „Mein Konto“ umschaltbar — dann bleibt alles bei den eigenen Daten."],
      ],
    },
    gemeinsam: {
      titel: "Gemeinsam nutzen",
      absatz: "Im Cloud-Modus sehen alle Konten dieselben Weine und können ihre "
        + "Bewertungen teilen. Was privat bleibt, bleibt privat: Bestände, Lagerorte "
        + "und Preise werden nie übertragen.",
      punkte: [
        ["Alle Weine", "Im Menü unter „Anzeigen“. Keller-, Wein- und Winzerliste zeigen dann "
          + "auch, was nur im gemeinsamen Katalog steht. Solche Weine lassen sich wie eigene "
          + "öffnen und bearbeiten — beim ersten Einlagern, Anlegen eines Jahrgangs oder "
          + "Erfassen einer Kritik wandern sie samt Winzer und Region in den eigenen Keller."],
        ["Kritiken teilen", "Unter „Mein Konto“ im Menü. Ist es eingeschaltet — die Vorgabe —, "
          + "sind Bewertung, Kritiker, Speisenbegleitung und Verkostungsnotiz für alle Konten "
          + "sichtbar, zusammen mit deinem Benutzernamen. Der Anlass bleibt privat."],
        ["Widerruf wirkt rückwärts", "Wird das Teilen abgeschaltet, verschwinden auch die "
          + "bereits geteilten Kritiken sofort bei allen anderen — nicht erst die künftigen."],
        ["Fremde Kritiken sehen", "In der Weinansicht steht unter der eigenen Tabelle „Alle "
          + "Kritiken einblenden“, sofern es welche gibt. Sie tragen den Namen des Kontos und "
          + "lassen sich nicht bearbeiten; die eigene Sicht bleibt der Ausgangspunkt."],
        ["Was nie geteilt wird", "Der Anlass einer Verkostung, Bestände, Lagerorte, Kaufpreise, Weinkarten und Kritiken "
          + "ohne zugeordneten Wein. Letztere sagen ohne Wein ohnehin niemandem etwas."],
      ],
    },
    daten: {
      titel: "Daten und Sicherung",
      absatz: "Der Stand liegt auf dem Server und zusätzlich als Kopie im Browser. "
        + "Ohne Verbindung wird lokal weitergearbeitet und später abgeglichen.",
      punkte: [
        ["Excel-Export", "Sichert Stammdaten, Bestände, Kritiken, Trink- und Kaufhistorie sowie offene Weinkarten. "
          + "Etikettenfotos sind nicht enthalten."],
        ["Excel-Import", "Dieselbe Mappe lässt sich wieder einlesen. Ein zweiter Import erzeugt keine Dubletten."],
        ["Leere Vorlage", "Eine Mappe mit allen Blättern und einem Hinweisblatt — für den Einstieg mit vielen Weinen."],
        ["Witterung", "Zu Regionen mit Koordinaten lassen sich Wetter- und Klimadaten laden "
          + "(Open-Meteo) und Jahrgänge im Jahresvergleich betrachten."],
        ["Zusammenführen", "Findet doppelt angelegte Winzer, Regionen und Weine und fasst sie zusammen."],
      ],
    },
  },

  en: {
    "erste-schritte": {
      titel: "Getting started",
      absatz: "The cellar book has three levels: a region (Mosel, say) holds producers, "
        + "a producer holds wines, a wine holds vintages. Stock always sits with the "
        + "vintage, never with the wine.",
      punkte: [
        ["Work from the top down", "Region first, then producer, then wine. If the producer is missing when "
          + "you add a wine, you can create them in the same form — along with a new region."],
        ["Regions with coordinates", "Latitude and longitude are optional, but they are what the world map and "
          + "the weather data build on. You can add them later at any time."],
        ["Adding a vintage", "From a wine’s page. That is where stock per bottle size, purchase price, "
          + "storage location, drinking window and the analysis values live."],
        ["No vintage", "For Champagne cuvées and similar wines there is “N.V.” — a wine may have several of them."],
      ],
    },
    keller: {
      titel: "Cellar, stocking and drinking",
      absatz: "The cellar shows what is actually on the rack. Every movement is recorded, "
        + "so that drinking and purchase history stay open to analysis later on.",
      punkte: [
        ["Stocking up", "Book new bottles with purchase date, source and price. The price feeds into the statistics."],
        ["Taking out", "Book bottles you have drunk. A review of that vintage can be added straight afterwards."],
        ["Moving", "Shift bottles between storage locations without changing the stock."],
        ["Scope of the lists", "In the menu under “Show”: “Cellar with stock” hides vintages "
          + "you have finished (they are kept, with their reviews and history), “Entire cellar” "
          + "shows them too, “All wines” adds the shared catalogue."],
      ],
    },
    verlauf: {
      titel: "Cellar log and reviews",
      absatz: "The cellar log is the chronicle of your cellar: additions, removals, "
        + "wine-list bookings and reviews stand side by side, grouped by month. "
        + "In the menu, directly below “Statistics”.",
      punkte: [
        ["Filtering", "Via the drop-down by kind (additions, removals, wine list, reviews, "
          + "unassigned), by year, and by "
          + "searching for wine, producer, merchant or critic."],
        ["Recording a review", "Via the button in the cellar log. Search for the wine, choose the "
          + "vintage, rate it — the view then jumps to that vintage. If the wine is missing, "
          + "it can be created in the same form, together with producer and region."],
        ["Without a wine", "When the wine isn’t settled yet: “Save without a wine”. A note "
          + "helps you recognise it later, but it isn’t required. Such reviews appear in the "
          + "cellar log under “Unassigned” and can be attached to a wine there later."],
        ["Label first", "The photograph may be taken before the wine is known — it is exactly "
          + "what helps with assigning it afterwards. On assignment it moves to the vintage "
          + "without being uploaded again."],
        ["Older reviews", "Reviews without a timestamp of their own appear at the date of the "
          + "most recent removal of the same vintage; this is marked as borrowed. If there was "
          + "never a removal, they sit under “No date”."],
      ],
    },
    finden: {
      titel: "Finding and organising",
      absatz: "Search and filters work across the cellar, the wine list and the statistics. "
        + "Your settings are remembered, even after a reload.",
      punkte: [
        ["Search field", "The cross on the right clears the entry. Next to it, two icons open the "
          + "filters (funnel) and the sorting (bars); a dot shows that something is set."],
        ["Filters", "By type, country, region, producer, grape variety, vintage, storage location, "
          + "drinking maturity and favourite. Each filter takes several values at once — several vintages, for instance."],
        ["Label", "A free text field on the wine for your own grouping — “New Wave Chardonnay”, for instance. "
          + "Labels can be filtered on and can structure the PDF wine list."],
        ["Drinking maturity", "The drinking window tells you whether a vintage is still too young, "
          + "at its peak, or past it."],
        ["Reviews", "In four rating scales, optionally with occasion and food pairing. "
          + "The default scale is set in the menu under “My account”."],
      ],
    },
    teilen: {
      titel: "Sharing and wine lists",
      absatz: "Both produce a link that opens without signing in. For each share you decide "
        + "separately which details are visible — anything hidden is never sent in the first place.",
      punkte: [
        ["Share the cellar", "Shows your holdings as a whole."],
        ["Wine list", "A selection with prices of your own. Its bottles are taken out of the cellar; "
          + "“Poured” books them as drunk, the × puts them back."],
        ["PDF", "The wine list can be saved as a PDF — optionally with a table of contents and page numbers, "
          + "grouped by origin or by label."],
        ["Language", "A shared list can open in a fixed language; guests are free to switch."],
      ],
    },
    katalog: {
      titel: "Shared catalogue",
      absatz: "In cloud mode all accounts share one catalogue of master data. Stock, prices "
        + "and notes are untouched by it — those are always private.",
      punkte: [
        ["Taking data over", "When adding a wine you can search for a wine or for a producer. "
          + "Going by producer brings up their wines to choose from."],
        ["Vintages", "They are not taken over automatically. When adding a vintage, “Available in "
          + "the catalogue” lists the years the catalogue knows for this wine; picking one takes "
          + "over drinking window, label and analysis values. Your own entries are left alone."],
        ["Proposing changes", "Edits to master data you took over go to the administrators as a proposal."],
        ["Local instead of cloud", "Switchable under “My account” — everything then stays with your own data."],
      ],
    },
    gemeinsam: {
      titel: "Sharing with others",
      absatz: "In cloud mode all accounts see the same wines and may share their "
        + "ratings. What is private stays private: stock, storage locations and "
        + "prices are never transferred.",
      punkte: [
        ["All wines", "In the menu under “Show”. Cellar, wine and producer lists then also "
          + "show what exists only in the shared catalogue. Such wines open and edit like your "
          + "own — the first time you store a bottle, add a vintage or record a rating, they "
          + "move into your cellar together with producer and region."],
        ["Sharing ratings", "Under “My account” in the menu. When switched on — the default — "
          + "rating, critic, food pairing and tasting note are visible to all accounts, "
          + "together with your user name. The occasion stays private."],
        ["Withdrawal works backwards", "Switching sharing off also removes the ratings already "
          + "shared, immediately and for everyone — not just future ones."],
        ["Seeing others’ ratings", "On the wine’s page, below your own table, “Show all ratings” "
          + "appears whenever there are any. They carry the account’s name and cannot be edited; "
          + "your own view stays the starting point."],
        ["Never shared", "The occasion of a tasting, stock, storage locations, purchase prices, wine lists and ratings "
          + "without an assigned wine. The latter would mean nothing to anyone anyway."],
      ],
    },
    daten: {
      titel: "Data and backups",
      absatz: "Your data lives on the server and additionally as a copy in the browser. "
        + "Without a connection you carry on locally, and it is reconciled later.",
      punkte: [
        ["Excel export", "Saves master data, stock, reviews, drinking and purchase history, and open wine lists. "
          + "Label photographs are not included."],
        ["Excel import", "The same workbook can be read back in. A second import creates no duplicates."],
        ["Blank template", "A workbook with every sheet and a notes page — for getting started with many wines."],
        ["Weather", "For regions with coordinates you can load weather and climate data (Open-Meteo) "
          + "and compare vintages year by year."],
        ["Merging", "Finds producers, regions and wines entered twice and joins them together."],
      ],
    },
  },

  es: {
    "erste-schritte": {
      titel: "Primeros pasos",
      absatz: "La bodega tiene tres niveles: una región (por ejemplo, el Mosela) contiene "
        + "bodegueros, un bodeguero sus vinos y un vino sus añadas. Las existencias van "
        + "siempre con la añada, nunca con el vino.",
      punkte: [
        ["Crear de arriba abajo", "Primero la región, después el bodeguero y luego el vino. Si al crear un vino "
          + "falta el bodeguero, se puede añadir en el mismo formulario, junto con una región nueva."],
        ["Regiones con coordenadas", "La latitud y la longitud son opcionales, pero son la base del mapamundi "
          + "y de los datos meteorológicos. Se pueden añadir en cualquier momento."],
        ["Crear una añada", "Desde la ficha de un vino. Allí están las existencias por formato, el precio de compra, "
          + "el lugar de guarda, la ventana de consumo y los valores analíticos."],
        ["Sin añada", "Para cupages de champán y vinos similares existe «N.V.»; un vino puede tener varios."],
      ],
    },
    keller: {
      titel: "Bodega, entradas y salidas",
      absatz: "La bodega muestra lo que hay realmente. Cada movimiento queda registrado, "
        + "de modo que el historial de consumo y de compra siga siendo analizable.",
      punkte: [
        ["Entrada", "Registra botellas nuevas con fecha de compra, proveedor y precio. El precio pasa a las estadísticas."],
        ["Salida", "Da de baja las botellas bebidas. Justo después se puede anotar una cata de esa añada."],
        ["Traslado", "Mueve botellas entre lugares de guarda sin alterar las existencias."],
        ["Alcance de las listas", "En el menú, en «Mostrar»: «Bodega con existencias» oculta "
          + "las añadas ya terminadas (se conservan, con sus catas y su historial), «Bodega "
          + "completa» también las muestra y «Todos los vinos» añade el catálogo común."],
      ],
    },
    verlauf: {
      titel: "Historial y críticas",
      absatz: "El historial es la crónica de la bodega: entradas, salidas, reservas de "
        + "cartas de vinos y críticas aparecen juntas, agrupadas por meses. "
        + "En el menú, justo debajo de «Estadísticas».",
      punkte: [
        ["Filtrar", "Con la lista desplegable por tipo (entradas, salidas, carta de vinos, "
          + "críticas, sin asignar), por año y "
          + "mediante la búsqueda por vino, bodega, distribuidor o crítico."],
        ["Registrar una crítica", "Con el botón del historial. Busca el vino, elige la añada y "
          + "valora; después la vista salta a esa añada. Si el vino aún no existe, puede "
          + "crearse en el mismo formulario, junto con la bodega y la región."],
        ["Sin vino asignado", "Cuando el vino todavía no está claro: «Guardar sin vino». Una "
          + "nota ayuda a reconocerlo después, pero no es obligatoria. Estas críticas aparecen "
          + "en el historial bajo «Sin asignar» y allí pueden asignarse más tarde."],
        ["La etiqueta primero", "La foto puede hacerse antes de saber qué vino es: es "
          + "justamente lo que ayuda a asignarlo después. Al asignarlo pasa a la añada sin "
          + "volver a subirse."],
        ["Críticas antiguas", "Las críticas sin fecha propia aparecen en la fecha de la última "
          + "salida de la misma añada, señalada como prestada. Si nunca hubo una salida, "
          + "quedan bajo «Sin fecha»."],
      ],
    },
    finden: {
      titel: "Buscar y ordenar",
      absatz: "La búsqueda y los filtros actúan en la bodega, la lista de vinos y las estadísticas. "
        + "Los ajustes se conservan, incluso al recargar.",
      punkte: [
        ["Campo de búsqueda", "La cruz de la derecha borra lo escrito. Al lado, dos iconos abren "
          + "los filtros (embudo) y la ordenación (barras); un punto indica que hay algo activo."],
        ["Filtros", "Por tipo, país, región, bodeguero, variedad, añada, lugar de guarda, "
          + "punto de consumo y vino favorito. En cada filtro pueden marcarse varios valores, por ejemplo varias añadas."],
        ["Etiqueta", "Un campo libre en el vino para tu propia clasificación, por ejemplo «New Wave Chardonnay». "
          + "Se puede filtrar por etiqueta y estructurar con ella la carta de vinos en PDF."],
        ["Punto de consumo", "La ventana de consumo indica si una añada es aún joven, está en su punto o lo ha pasado."],
        ["Catas", "En cuatro escalas de puntuación, opcionalmente con ocasión y maridaje. "
          + "La escala predeterminada se fija en el menú, en «Mi cuenta»."],
      ],
    },
    teilen: {
      titel: "Compartir y cartas de vinos",
      absatz: "Ambos generan un enlace que se abre sin iniciar sesión. En cada publicación decides "
        + "por separado qué datos son visibles: lo oculto ni siquiera se transmite.",
      punkte: [
        ["Compartir la bodega", "Muestra todas tus existencias."],
        ["Carta de vinos", "Una selección con precios propios. Sus botellas están sacadas de la bodega; "
          + "«Servido» las registra como bebidas y la × las devuelve."],
        ["PDF", "La carta puede guardarse en PDF, con índice y números de página si quieres, "
          + "ordenada por procedencia o por etiqueta."],
        ["Idioma", "La carta compartida puede abrirse en un idioma fijo; los invitados pueden cambiarlo."],
      ],
    },
    katalog: {
      titel: "Catálogo común",
      absatz: "En modo nube todas las cuentas comparten un catálogo de datos maestros. "
        + "Existencias, precios y notas quedan al margen: siempre son privados.",
      punkte: [
        ["Tomar del catálogo", "Al crear un vino puedes buscar por vino o por bodeguero. "
          + "Si vas por el bodeguero, aparecen sus vinos para elegir."],
        ["Añadas", "No se toman automáticamente. Al crear una añada, «Disponible en el catálogo» "
          + "muestra los años que el catálogo conoce de este vino; al elegir uno se adoptan la "
          + "ventana de consumo, la etiqueta y los valores analíticos. Tus propios datos se mantienen."],
        ["Proponer cambios", "Las modificaciones de datos maestros tomados del catálogo llegan "
          + "a la administración como propuesta."],
        ["Local en vez de nube", "Se cambia en «Mi cuenta»; entonces todo se queda en tus propios datos."],
      ],
    },
    gemeinsam: {
      titel: "Uso compartido",
      absatz: "En modo nube todas las cuentas ven los mismos vinos y pueden compartir "
        + "sus valoraciones. Lo privado sigue siendo privado: existencias, lugares de "
        + "guarda y precios no se transmiten nunca.",
      punkte: [
        ["Todos los vinos", "En el menú, en «Mostrar». Las listas de bodega, vinos y bodegueros "
          + "muestran entonces también lo que solo está en el catálogo común. Esos vinos se "
          + "abren y editan como los propios: al guardar una botella, crear una añada o "
          + "registrar una crítica pasan a tu bodega junto con bodeguero y región."],
        ["Compartir críticas", "En «Mi cuenta», dentro del menú. Si está activado —la opción "
          + "predeterminada—, la puntuación, el crítico, el maridaje y la nota de cata son visibles "
          + "para todas las cuentas, junto con tu nombre de usuario. La ocasión queda privada."],
        ["La revocación actúa hacia atrás", "Al desactivar el uso compartido desaparecen también "
          + "las críticas ya compartidas, de inmediato y para todos, no solo las futuras."],
        ["Ver críticas ajenas", "En la ficha del vino, bajo tu propia tabla, aparece «Mostrar "
          + "todas las críticas» siempre que las haya. Llevan el nombre de la cuenta y no se "
          + "pueden editar; tu propia visión sigue siendo el punto de partida."],
        ["Lo que nunca se comparte", "La ocasión de una cata, existencias, lugares de guarda, precios de compra, cartas "
          + "de vinos y críticas sin vino asignado. Estas últimas no dirían nada a nadie."],
      ],
    },
    daten: {
      titel: "Datos y copias de seguridad",
      absatz: "Tus datos están en el servidor y, además, como copia en el navegador. "
        + "Sin conexión se sigue trabajando en local y luego se sincroniza.",
      punkte: [
        ["Exportar a Excel", "Guarda datos maestros, existencias, catas, historial de consumo y de compra "
          + "y las cartas de vinos abiertas. Las fotos de etiquetas no se incluyen."],
        ["Importar de Excel", "El mismo libro se puede volver a leer. Una segunda importación no crea duplicados."],
        ["Plantilla vacía", "Un libro con todas las hojas y una hoja de indicaciones, para empezar con muchos vinos."],
        ["Meteorología", "Para regiones con coordenadas se pueden cargar datos meteorológicos y climáticos "
          + "(Open-Meteo) y comparar añadas año por año."],
        ["Unificar", "Encuentra bodegueros, regiones y vinos creados por duplicado y los une."],
      ],
    },
  },

  fr: {
    "erste-schritte": {
      titel: "Premiers pas",
      absatz: "Le livre de cave comporte trois niveaux : une région (la Moselle, par exemple) "
        + "regroupe des vignerons, un vigneron ses vins, un vin ses millésimes. Les stocks "
        + "sont toujours rattachés au millésime, jamais au vin.",
      punkte: [
        ["Créer de haut en bas", "D’abord la région, puis le vigneron, puis le vin. Si le vigneron manque "
          + "au moment de créer un vin, on peut le saisir dans le même formulaire, avec une nouvelle région."],
        ["Régions et coordonnées", "La latitude et la longitude sont facultatives, mais elles fondent la carte "
          + "du monde et les données météo. On peut les ajouter à tout moment."],
        ["Créer un millésime", "Depuis la fiche d’un vin. On y trouve le stock par contenance, le prix d’achat, "
          + "le lieu de garde, la fenêtre de dégustation et les valeurs analytiques."],
        ["Sans millésime", "Pour les cuvées de champagne et vins semblables, il y a « N.V. » — un vin peut en avoir plusieurs."],
      ],
    },
    keller: {
      titel: "Cave, entrées et sorties",
      absatz: "La cave montre ce qui s’y trouve réellement. Chaque mouvement est consigné, "
        + "afin que l’historique de consommation et d’achat reste exploitable.",
      punkte: [
        ["Entrée", "Enregistrez de nouvelles bouteilles avec la date d’achat, la source et le prix. "
          + "Le prix alimente les statistiques."],
        ["Sortie", "Sortez les bouteilles bues. Une critique du millésime peut être saisie dans la foulée."],
        ["Déplacement", "Déplacez des bouteilles entre lieux de garde sans modifier le stock."],
        ["Portée des listes", "Dans le menu, sous « Afficher » : « Cave avec stock » masque "
          + "les millésimes épuisés (ils sont conservés, avec leurs critiques et leur "
          + "historique), « Cave entière » les montre aussi, « Tous les vins » ajoute le "
          + "catalogue commun."],
      ],
    },
    verlauf: {
      titel: "Historique et critiques",
      absatz: "L’historique est la chronique de la cave : entrées, sorties, réservations pour "
        + "les cartes des vins et critiques y figurent côte à côte, regroupées par mois. "
        + "Dans le menu, juste sous « Statistiques ».",
      punkte: [
        ["Filtrer", "Via la liste déroulante par type (entrées, sorties, carte des vins, "
          + "critiques, non attribué), par année et par "
          + "recherche sur le vin, le vigneron, le caviste ou le critique."],
        ["Saisir une critique", "Via le bouton de l’historique. Cherchez le vin, choisissez le "
          + "millésime, notez — la vue passe ensuite au millésime. Si le vin manque encore, il "
          + "peut être créé dans le même formulaire, avec son vigneron et sa région."],
        ["Sans vin", "Lorsque le vin n’est pas encore identifié : « Enregistrer sans vin ». Une "
          + "note aide à le reconnaître plus tard, mais elle n’est pas obligatoire. Ces "
          + "critiques apparaissent dans l’historique sous « Non attribué » et peuvent y être "
          + "rattachées à un vin plus tard."],
        ["L’étiquette d’abord", "La photo peut être prise avant de savoir de quel vin il "
          + "s’agit — c’est précisément ce qui aide à l’attribuer ensuite. Lors de "
          + "l’attribution, elle passe au millésime sans être renvoyée."],
        ["Critiques anciennes", "Les critiques sans horodatage propre apparaissent à la date de "
          + "la dernière sortie du même millésime ; cela est signalé comme emprunté. S’il n’y a "
          + "jamais eu de sortie, elles figurent sous « Sans date »."],
      ],
    },
    finden: {
      titel: "Trouver et organiser",
      absatz: "La recherche et les filtres agissent sur la cave, la liste des vins et les statistiques. "
        + "Les réglages sont conservés, même après un rechargement.",
      punkte: [
        ["Champ de recherche", "La croix à droite efface la saisie. À côté, deux icônes ouvrent "
          + "les filtres (entonnoir) et le tri (barres) ; un point signale qu’un réglage est actif."],
        ["Filtres", "Par type, pays, région, vigneron, cépage, millésime, lieu de garde, "
          + "maturité et coup de cœur. Chaque filtre accepte plusieurs valeurs, par exemple plusieurs millésimes."],
        ["Label", "Un champ libre sur le vin pour votre propre classement — « New Wave Chardonnay », par exemple. "
          + "Les labels servent de filtre et peuvent structurer la carte des vins en PDF."],
        ["Maturité", "La fenêtre de dégustation indique si un millésime est encore jeune, à son apogée ou passé."],
        ["Critiques", "Selon quatre barèmes de notation, avec occasion et accord mets-vins en option. "
          + "Le barème par défaut se règle dans le menu, sous « Mon compte »."],
      ],
    },
    teilen: {
      titel: "Partage et cartes des vins",
      absatz: "L’un comme l’autre produisent un lien consultable sans connexion au compte. "
        + "Pour chaque partage, vous décidez séparément des informations visibles — "
        + "ce qui est masqué n’est même pas transmis.",
      punkte: [
        ["Partager la cave", "Montre l’ensemble de vos bouteilles."],
        ["Carte des vins", "Une sélection avec vos propres prix. Ses bouteilles sont sorties de la cave ; "
          + "« Servi » les compte comme bues, la × les remet en cave."],
        ["PDF", "La carte peut être enregistrée en PDF, au choix avec sommaire et numéros de page, "
          + "classée par provenance ou par label."],
        ["Langue", "La carte partagée peut s’ouvrir dans une langue fixe ; les invités restent libres d’en changer."],
      ],
    },
    katalog: {
      titel: "Catalogue commun",
      absatz: "En mode cloud, tous les comptes partagent un catalogue de données de référence. "
        + "Stocks, prix et notes n’en font pas partie : ils restent toujours privés.",
      punkte: [
        ["Reprendre du catalogue", "Lors de la création d’un vin, on peut chercher un vin ou un vigneron. "
          + "En passant par le vigneron, ses vins s’affichent au choix."],
        ["Millésimes", "Ils ne sont pas repris automatiquement. Lors de la création d’un "
          + "millésime, « Disponible dans le catalogue » indique les années connues pour ce vin ; "
          + "en choisir une reprend la fenêtre de dégustation, l’étiquette et les valeurs "
          + "analytiques. Vos propres saisies sont conservées."],
        ["Proposer une modification", "Les modifications de données reprises partent en proposition à l’administration."],
        ["Local plutôt que cloud", "Commutable sous « Mon compte » : tout reste alors dans vos propres données."],
      ],
    },
    gemeinsam: {
      titel: "Utilisation partagée",
      absatz: "En mode cloud, tous les comptes voient les mêmes vins et peuvent partager "
        + "leurs notes. Ce qui est privé le reste : stocks, lieux de garde et prix ne "
        + "sont jamais transmis.",
      punkte: [
        ["Tous les vins", "Dans le menu, sous « Afficher ». Les listes de cave, de vins et de "
          + "vignerons montrent alors aussi ce qui n’existe que dans le catalogue commun. Ces "
          + "vins s’ouvrent et se modifient comme les vôtres : au premier rangement, à la "
          + "création d’un millésime ou à la saisie d’une critique, ils rejoignent votre cave "
          + "avec leur vigneron et leur région."],
        ["Partager ses critiques", "Sous « Mon compte », dans le menu. Si l’option est activée "
          + "— le réglage par défaut —, la note, le critique, l’accord mets-vins et la remarque sont visibles "
          + "par tous les comptes, avec votre nom d’utilisateur. L’occasion reste privée."],
        ["La révocation agit rétroactivement", "Désactiver le partage supprime aussi les "
          + "critiques déjà partagées, immédiatement et pour tous — pas seulement les futures."],
        ["Voir les critiques des autres", "Sur la fiche du vin, sous votre propre tableau, "
          + "« Afficher toutes les critiques » apparaît dès qu’il y en a. Elles portent le nom "
          + "du compte et ne sont pas modifiables ; votre propre vue reste le point de départ."],
        ["Jamais partagé", "L’occasion d’une dégustation, stocks, lieux de garde, prix d’achat, cartes des vins et critiques "
          + "sans vin attribué. Ces dernières ne diraient rien à personne."],
      ],
    },
    daten: {
      titel: "Données et sauvegarde",
      absatz: "Vos données sont sur le serveur et, en plus, en copie dans le navigateur. "
        + "Sans connexion, le travail se poursuit en local et se synchronise plus tard.",
      punkte: [
        ["Export Excel", "Sauvegarde les données de référence, les stocks, les critiques, l’historique de "
          + "consommation et d’achat ainsi que les cartes en cours. Les photos d’étiquettes n’y figurent pas."],
        ["Import Excel", "Le même classeur peut être relu. Un second import ne crée pas de doublons."],
        ["Modèle vierge", "Un classeur avec tous les feuillets et une page d’explications — "
          + "pratique pour démarrer avec de nombreux vins."],
        ["Météo", "Pour les régions dotées de coordonnées, on peut charger des données météo et climatiques "
          + "(Open-Meteo) et comparer les millésimes d’une année à l’autre."],
        ["Fusionner", "Repère les vignerons, régions et vins saisis en double et les réunit."],
      ],
    },
  },
};

/* Reihenfolge der Abschnitte — für alle Sprachen dieselbe. */
const REIHENFOLGE = ["erste-schritte", "keller", "verlauf", "finden", "teilen", "katalog", "gemeinsam", "daten"];

/* Schlüssel des Witterungspunkts im Datenabschnitt, damit das Panel
   ihn ohne Kenntnis der Übersetzung entfernen kann. */
const WITTERUNG_INDEX = 3;

function infoTexte(code) {
  return TEXTE[code] || TEXTE.de;
}

export { REIHENFOLGE, TEXTE, WITTERUNG_INDEX, infoTexte };
